import { z } from 'zod';

/**
 * Validation for practice mode inputs.
 * Custom text is restricted to printable characters to prevent XSS vectors
 * even though rendering uses text nodes only.
 */

const PRINTABLE = /^[\x20-\x7E\n\r\t]+$/;

export const CustomTextSchema = z
  .string()
  .min(10, 'Custom text must be at least 10 characters.')
  .max(2000, 'Custom text must be 2000 characters or fewer.')
  .refine((s) => PRINTABLE.test(s), 'Custom text contains unsupported characters.')
  .refine((s) => !/[<>]/.test(s), 'Custom text may not contain < or >.');

export const PracticeModeSchema = z.enum(['free', 'timed', 'common', 'custom', 'weak']);

export const WeakKeyDrillSchema = z.object({
  keys: z.array(z.string().min(1).max(2)).min(3).max(10),
  length: z.number().int().min(50).max(500).default(150),
});